var kotemplates = require('../../template/kotemplates');

module.exports = {
  appError: {
    url: "#/appError",
    page: require("../../component/appError.html"),
  },
  prevent: {
    url: "#/prevent",
    initRoute: kotemplates.registerPrevent,
    page: require("../../component/prevent/preventIndex.html"),
  },
  secureClientMsg: {
    url: "#/secureClientMsg",
    page: require("../../component/secureClient/index.html"),
  },
  wechatMsg: {
    url: "#/wechatMsg",
    initRoute: kotemplates.registerWechatMsg,
    page: require("../../component/login/wechatMsg/index.html"),
  }
}


//////////////////
// WEBPACK FOOTER
// ./src/routes/config/display.js
// module id = 197
// module chunks = 0